var _circle, _circle2, _circle3, _circle4, _rect, _rect2, _rect3, _g, _rect4, _rect5, _rect6, _rect7, _path, _path2, _path3, _path4, _path5, _rect8, _rect9, _rect10, _path6, _line, _g2, _circle5, _g3, _circle6, _g4, _circle7, _g5, _circle8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 268,
    viewBox: "0 0 308 268",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0601,
    cy: 200.705,
    r: 34.0601,
    fill: "#342E36"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.0332,
    cy: 201.678,
    r: 27.2481,
    fill: "#82675C"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.0601,
    cy: 200.705,
    r: 20.4361,
    fill: "#C79A7E"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.6008,
    cy: 201.246,
    r: 9.73146,
    fill: "url(#paint0_linear_143_28)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 261.004,
    y: 23.2429,
    width: 68.8966,
    height: 68.8966,
    rx: 16,
    transform: "rotate(46.9897 261.004 23.2429)",
    fill: "#233E46"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 255.237,
    y: 22.9796,
    width: 68.5055,
    height: 68.5055,
    rx: 15,
    transform: "rotate(46.9897 255.237 22.9796)",
    fill: "#2A7270"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 254.97,
    y: 33.0709,
    width: 52.1994,
    height: 52.1994,
    rx: 13,
    transform: "rotate(46.9897 254.97 33.0709)",
    fill: "#48E3D7",
    fillOpacity: 0.83
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_143_28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 42.2815,
    y: 11.6129,
    width: 216.106,
    height: 238.029,
    rx: 45,
    fill: "#2E2D3D",
    fillOpacity: 0.61
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 79.865,
    y: 60.1583,
    width: 145.636,
    height: 11.7449,
    rx: 5.87243,
    fill: "#48485D"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 78.2991,
    y: 146.287,
    width: 145.636,
    height: 11.7449,
    rx: 5.87243,
    fill: "#48485D"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 77.5161,
    y: 189.352,
    width: 145.636,
    height: 11.7449,
    rx: 5.87243,
    fill: "#48485D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 79.865,
    y: 103.223,
    width: 145.636,
    height: 11.7449,
    rx: 5.87243,
    fill: "#48485D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.2418 10.3387V12.8387H97.2418V10.3387H92.2418ZM93.8635 6.87924L91.6654 8.07013V8.07013L93.8635 6.87924ZM91.436 4.23679L92.8119 2.14951V2.14951L91.436 4.23679ZM88.0325 3.03534L88.2743 0.547059L88.0325 3.03534ZM84.4568 3.55862L83.5111 1.2444H83.5111L84.4568 3.55862ZM81.5534 5.68306L79.6315 4.0843L79.6315 4.0843L81.5534 5.68306ZM80.0079 8.90695L82.4586 9.40105L80.0079 8.90695ZM80.1853 12.4689L82.5749 11.7342L80.1853 12.4689ZM80.2879 17.3075C81.2707 18.2772 82.8536 18.2665 83.8233 17.2837C84.793 16.3008 84.7823 14.7179 83.7994 13.7482L80.2879 17.3075ZM97.2418 10.3387C97.2418 8.71459 96.8358 7.1172 96.0616 5.68834L91.6654 8.07013C92.0445 8.76996 92.2418 9.54902 92.2418 10.3387H97.2418ZM96.0616 5.68834C95.2876 4.25967 94.1704 3.04505 92.8119 2.14951L90.06 6.32406C90.7357 6.76951 91.2861 7.37011 91.6654 8.07013L96.0616 5.68834ZM92.8119 2.14951C91.4536 1.2541 89.895 0.704546 88.2743 0.547059L87.7907 5.52362C88.6047 5.60272 89.3841 5.8785 90.06 6.32406L92.8119 2.14951ZM88.2743 0.547059C86.6536 0.389576 85.0178 0.628685 83.5111 1.2444L85.4026 5.87284C86.1562 5.56488 86.9767 5.44452 87.7907 5.52362L88.2743 0.547059ZM83.5111 1.2444C82.0043 1.86018 80.6711 2.83455 79.6315 4.0843L83.4754 7.28182C83.9879 6.66576 84.6491 6.18074 85.4026 5.87284L83.5111 1.2444ZM79.6315 4.0843C78.5917 5.33424 77.8782 6.82072 77.5572 8.41285L82.4586 9.40105C82.6149 8.62586 82.9631 7.8977 83.4754 7.28182L79.6315 4.0843ZM77.5572 8.41285C77.2362 10.0051 77.3183 11.6509 77.7957 13.2037L82.5749 11.7342C82.3421 10.9772 82.3023 10.1761 82.4586 9.40105L77.5572 8.41285ZM77.7957 13.2037C78.2731 14.7563 79.1302 16.1654 80.2879 17.3075L83.7994 13.7482C83.2272 13.1836 82.8077 12.4914 82.5749 11.7342L77.7957 13.2037Z",
    fill: "#48485D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M120.43 10.3387V12.8387H125.43V10.3387H120.43ZM122.051 6.87924L119.853 8.07013V8.07013L122.051 6.87924ZM119.624 4.23679L121 2.14951V2.14951L119.624 4.23679ZM116.22 3.03534L116.462 0.547059L116.22 3.03534ZM112.645 3.55862L111.699 1.2444H111.699L112.645 3.55862ZM109.741 5.68306L107.819 4.0843L107.819 4.0843L109.741 5.68306ZM108.196 8.90695L110.646 9.40105L108.196 8.90695ZM108.373 12.4689L110.763 11.7342L108.373 12.4689ZM108.476 17.3075C109.458 18.2772 111.041 18.2665 112.011 17.2837C112.981 16.3008 112.97 14.7179 111.987 13.7482L108.476 17.3075ZM125.43 10.3387C125.43 8.71459 125.024 7.1172 124.249 5.68834L119.853 8.07013C120.232 8.76996 120.43 9.54902 120.43 10.3387H125.43ZM124.249 5.68834C123.475 4.25967 122.358 3.04505 121 2.14951L118.248 6.32406C118.923 6.76951 119.474 7.37011 119.853 8.07013L124.249 5.68834ZM121 2.14951C119.641 1.2541 118.083 0.704546 116.462 0.547059L115.978 5.52362C116.792 5.60272 117.572 5.8785 118.248 6.32406L121 2.14951ZM116.462 0.547059C114.841 0.389576 113.206 0.628685 111.699 1.2444L113.59 5.87284C114.344 5.56488 115.164 5.44452 115.978 5.52362L116.462 0.547059ZM111.699 1.2444C110.192 1.86018 108.859 2.83455 107.819 4.0843L111.663 7.28182C112.176 6.66576 112.837 6.18074 113.59 5.87284L111.699 1.2444ZM107.819 4.0843C106.779 5.33424 106.066 6.82072 105.745 8.41285L110.646 9.40105C110.803 8.62586 111.151 7.8977 111.663 7.28182L107.819 4.0843ZM105.745 8.41285C105.424 10.0051 105.506 11.6509 105.983 13.2037L110.763 11.7342C110.53 10.9772 110.49 10.1761 110.646 9.40105L105.745 8.41285ZM105.983 13.2037C106.461 14.7563 107.318 16.1654 108.476 17.3075L111.987 13.7482C111.415 13.1836 110.995 12.4914 110.763 11.7342L105.983 13.2037Z",
    fill: "#48485D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.617 10.3387V12.8387H153.617V10.3387H148.617ZM150.239 6.87924L148.041 8.07013V8.07013L150.239 6.87924ZM147.811 4.23679L149.187 2.14951V2.14951L147.811 4.23679ZM144.408 3.03534L144.65 0.547059L144.408 3.03534ZM140.832 3.55862L139.887 1.2444H139.887L140.832 3.55862ZM137.929 5.68306L136.007 4.0843L136.007 4.0843L137.929 5.68306ZM136.383 8.90695L138.834 9.40105L136.383 8.90695ZM136.561 12.4689L138.95 11.7342L136.561 12.4689ZM136.663 17.3075C137.646 18.2772 139.229 18.2665 140.199 17.2837C141.168 16.3008 141.158 14.7179 140.175 13.7482L136.663 17.3075ZM153.617 10.3387C153.617 8.71459 153.211 7.1172 152.437 5.68834L148.041 8.07013C148.42 8.76996 148.617 9.54902 148.617 10.3387H153.617ZM152.437 5.68834C151.663 4.25967 150.546 3.04505 149.187 2.14951L146.435 6.32406C147.111 6.76951 147.662 7.37011 148.041 8.07013L152.437 5.68834ZM149.187 2.14951C147.829 1.2541 146.271 0.704546 144.65 0.547059L144.166 5.52362C144.98 5.60272 145.76 5.8785 146.435 6.32406L149.187 2.14951ZM144.65 0.547059C143.029 0.389576 141.393 0.628685 139.887 1.2444L141.778 5.87284C142.532 5.56488 143.352 5.44452 144.166 5.52362L144.65 0.547059ZM139.887 1.2444C138.38 1.86018 137.047 2.83455 136.007 4.0843L139.851 7.28182C140.363 6.66576 141.025 6.18074 141.778 5.87284L139.887 1.2444ZM136.007 4.0843C134.967 5.33424 134.254 6.82072 133.933 8.41285L138.834 9.40105C138.99 8.62586 139.339 7.8977 139.851 7.28182L136.007 4.0843ZM133.933 8.41285C133.612 10.0051 133.694 11.6509 134.171 13.2037L138.95 11.7342C138.718 10.9772 138.678 10.1761 138.834 9.40105L133.933 8.41285ZM134.171 13.2037C134.649 14.7563 135.506 16.1654 136.663 17.3075L140.175 13.7482C139.603 13.1836 139.183 12.4914 138.95 11.7342L134.171 13.2037Z",
    fill: "#48485D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M176.805 10.3387V12.8387H181.805V10.3387H176.805ZM178.427 6.87924L176.229 8.07013V8.07013L178.427 6.87924ZM175.999 4.23679L177.375 2.14951V2.14951L175.999 4.23679ZM172.596 3.03534L172.838 0.547059L172.596 3.03534ZM169.02 3.55862L168.074 1.2444H168.074L169.02 3.55862ZM166.117 5.68306L164.195 4.0843L164.195 4.0843L166.117 5.68306ZM164.571 8.90695L167.022 9.40105L164.571 8.90695ZM164.749 12.4689L167.138 11.7342L164.749 12.4689ZM164.851 17.3075C165.834 18.2772 167.417 18.2665 168.387 17.2837C169.356 16.3008 169.346 14.7179 168.363 13.7482L164.851 17.3075ZM181.805 10.3387C181.805 8.71459 181.399 7.1172 180.625 5.68834L176.229 8.07013C176.608 8.76996 176.805 9.54902 176.805 10.3387H181.805ZM180.625 5.68834C179.851 4.25967 178.734 3.04505 177.375 2.14951L174.623 6.32406C175.299 6.76951 175.849 7.37011 176.229 8.07013L180.625 5.68834ZM177.375 2.14951C176.017 1.2541 174.458 0.704546 172.838 0.547059L172.354 5.52362C173.168 5.60272 173.947 5.8785 174.623 6.32406L177.375 2.14951ZM172.838 0.547059C171.217 0.389576 169.581 0.628685 168.074 1.2444L169.966 5.87284C170.719 5.56488 171.54 5.44452 172.354 5.52362L172.838 0.547059ZM168.074 1.2444C166.568 1.86018 165.234 2.83455 164.195 4.0843L168.039 7.28182C168.551 6.66576 169.212 6.18074 169.966 5.87284L168.074 1.2444ZM164.195 4.0843C163.155 5.33424 162.441 6.82072 162.12 8.41285L167.022 9.40105C167.178 8.62586 167.526 7.8977 168.039 7.28182L164.195 4.0843ZM162.12 8.41285C161.799 10.0051 161.881 11.6509 162.359 13.2037L167.138 11.7342C166.905 10.9772 166.866 10.1761 167.022 9.40105L162.12 8.41285ZM162.359 13.2037C162.836 14.7563 163.693 16.1654 164.851 17.3075L168.363 13.7482C167.79 13.1836 167.371 12.4914 167.138 11.7342L162.359 13.2037Z",
    fill: "#48485D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M204.993 10.3387V12.8387H209.993V10.3387H204.993ZM206.614 6.87924L204.416 8.07013V8.07013L206.614 6.87924ZM204.187 4.23679L205.563 2.14951V2.14951L204.187 4.23679ZM200.783 3.03534L201.025 0.547059L200.783 3.03534ZM197.208 3.55862L196.262 1.2444H196.262L197.208 3.55862ZM194.304 5.68306L192.382 4.0843L192.382 4.0843L194.304 5.68306ZM192.759 8.90695L195.209 9.40105L192.759 8.90695ZM192.936 12.4689L195.326 11.7342L192.936 12.4689ZM193.039 17.3075C194.021 18.2772 195.604 18.2665 196.574 17.2837C197.544 16.3008 197.533 14.7179 196.55 13.7482L193.039 17.3075ZM209.993 10.3387C209.993 8.71459 209.586 7.1172 208.812 5.68834L204.416 8.07013C204.795 8.76996 204.993 9.54902 204.993 10.3387H209.993ZM208.812 5.68834C208.038 4.25967 206.921 3.04505 205.563 2.14951L202.811 6.32406C203.486 6.76951 204.037 7.37011 204.416 8.07013L208.812 5.68834ZM205.563 2.14951C204.204 1.2541 202.646 0.704546 201.025 0.547059L200.541 5.52362C201.355 5.60272 202.135 5.8785 202.811 6.32406L205.563 2.14951ZM201.025 0.547059C199.404 0.389576 197.769 0.628685 196.262 1.2444L198.153 5.87284C198.907 5.56488 199.727 5.44452 200.541 5.52362L201.025 0.547059ZM196.262 1.2444C194.755 1.86018 193.422 2.83455 192.382 4.0843L196.226 7.28182C196.739 6.66576 197.4 6.18074 198.153 5.87284L196.262 1.2444ZM192.382 4.0843C191.342 5.33424 190.629 6.82072 190.308 8.41285L195.209 9.40105C195.366 8.62586 195.714 7.8977 196.226 7.28182L192.382 4.0843ZM190.308 8.41285C189.987 10.0051 190.069 11.6509 190.546 13.2037L195.326 11.7342C195.093 10.9772 195.053 10.1761 195.209 9.40105L190.308 8.41285ZM190.546 13.2037C191.024 14.7563 191.881 16.1654 193.039 17.3075L196.55 13.7482C195.978 13.1836 195.558 12.4914 195.326 11.7342L190.546 13.2037Z",
    fill: "#48485D"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 206.71,
    y: 189.352,
    width: 78.2991,
    height: 78.2991,
    rx: 34,
    fill: "#393153"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 213.235,
    y: 195.877,
    width: 64.1618,
    height: 64.1618,
    rx: 30,
    fill: "#8D72BD",
    fillOpacity: 0.68
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 219.76,
    y: 202.402,
    width: 52.1994,
    height: 52.1994,
    rx: 26,
    fill: "#987EF5",
    fillOpacity: 0.83
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.851 235.476L235.775 231.394L250.146 217.001L254.223 221.083L239.851 235.476ZM234.788 233.456L237.789 236.462L233.612 237.639L234.788 233.456ZM256.507 220.324L250.906 214.712C250.5 214.306 249.788 214.306 249.382 214.712L233.491 230.629C233.359 230.761 233.264 230.919 233.217 231.099L231.023 238.904C230.917 239.279 231.023 239.685 231.297 239.959C231.503 240.165 231.914 240.313 232.352 240.233L240.147 238.034C240.326 237.987 240.484 237.892 240.616 237.76L256.507 221.848C256.929 221.426 256.929 220.746 256.507 220.324Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 244.293,
    y1: 237.746,
    x2: 260.736,
    y2: 237.746,
    stroke: "white",
    strokeWidth: 5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_143_28)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.69795,
    transform: "matrix(-1 0 0 1 288.141 16.3109)",
    fill: "#C4C4C4"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 2.34897,
    transform: "matrix(-1 0 0 1 288.141 16.3109)",
    fill: "white"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_143_28)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.69795,
    transform: "matrix(-1 0 0 1 18.0088 64.8563)",
    fill: "#C4C4C4"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 2.34897,
    transform: "matrix(-1 0 0 1 18.0087 64.8563)",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_143_28)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.69795,
    transform: "matrix(-1 0 0 1 39.1497 255.123)",
    fill: "#C4C4C4"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 2.34897,
    transform: "matrix(-1 0 0 1 39.1496 255.123)",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_143_28)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 4.69795,
    transform: "matrix(-1 0 0 1 289.707 179.956)",
    fill: "#C4C4C4"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 2.34897,
    transform: "matrix(-1 0 0 1 289.707 179.956)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_143_28",
    x: 19.2815,
    y: -11.3871,
    width: 262.105,
    height: 284.029,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 11.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_143_28"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_143_28",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_143_28",
    x: 279.443,
    y: 7.61292,
    width: 17.396,
    height: 17.3959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_143_28"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_143_28",
    x: 9.31079,
    y: 56.1583,
    width: 17.396,
    height: 17.3959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_143_28"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_143_28",
    x: 30.4517,
    y: 246.425,
    width: 17.396,
    height: 17.3959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_143_28"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_143_28",
    x: 281.009,
    y: 171.258,
    width: 17.396,
    height: 17.3959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_143_28"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_143_28",
    x1: 26.9547,
    y1: 195.144,
    x2: 38.5397,
    y2: 206.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9A086"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E18077",
    stopOpacity: 0.77
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNotes);
export default __webpack_public_path__ + "static/media/noNotes.58423c93917e17e5a9f4ea48d7b155df.svg";
export { ForwardRef as ReactComponent };